import './App.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import  {QRCodeCanvas} from 'qrcode.react';
import qs from 'qs';

function App() {

  const audio = new Audio(process.env.PUBLIC_URL + '/son.mp3');

  const random = randomInt(4000, 5000);

  const [key_code, setKey_code] = useState('');

  const [uri, setUri] = useState('');

  const [gain, setGain] = useState(null);

  const array = [0,1,2];

  const animation = [0,0,0];

  //97527f15-6344-4b8a-89b4-7d8a8a4353d9
  const animation1 = [4640,4640,4640];

  //d23584fb-940d-4add-9f59-83e50bf83d1d
  const animation2 = [4510,4510,4510];

  //4aa500e6-d533-4d9a-a7b3-b33a8b5a6cb2
  const animation3 = [random, (random - 290), (random + 120)];

  const loadQrCode = async () => {
    if(gain){
      return;
    }

    const res = await axios.get('https://mitchells.web-treeosk.online/back/?key_Code=' + key_code);
    if(res.data.success && res.data.data.valide){
      console.log('valide');
      loadGain();
    }
  }

  const loadGain = async () => {
    const res_gain = await axios.post(
      'https://api-gain.web-treeosk.online/play',
      qs.stringify({
        input: {
          game_id: 'f0fda8f0-3562-4841-b36f-19f36100cc74',
          lang: 'fr',
          player_data: {
            key_code: key_code,
          },
        },
      }),
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      }
    );

    console.log(gain);
    setGain(res_gain.data.data);
    start(res_gain.data.data.id, res_gain.data.data.uri);
  }

  const start = (gain_id, uri) => {
    
    let animation = [];

    switch(gain_id){
      case '97527f15-6344-4b8a-89b4-7d8a8a4353d9':
        animation = animation1;
        break;
      case 'd23584fb-940d-4add-9f59-83e50bf83d1d':
        animation = animation2;
        break;
      default:
        animation = animation3;
        break;
    }

    setTimeout(() => {
      audio.play();
    }, 4500)

    setTimeout(() => {
      document.querySelectorAll('.lamelle').forEach((element, index) => {
        element.style.setProperty('background-position-y', `-${animation[index]}px`, 'important');
      });
      setTimeout(() => {
        setUri(uri);
      }, 15000);
      setTimeout(() => {
        audio.pause()
      }, 14000);
      console.log(uri);
    }, 5000);
  }

  useEffect(() => {
    const interval = setInterval(() => {
      console.log(gain);
      if (gain) {
        clearInterval(interval);
        return;
      }
      loadQrCode();
    }, 1000);
  
    return () => clearInterval(interval);
  }, [gain, key_code]);
  

  const getKeyCode = async () => {
    const res = await axios.get('https://mitchells.web-treeosk.online/back/?send_key=true');
    console.log(res.data.data.key_Code);
    setKey_code(res.data.data.key_Code);
  }

  useEffect(()=>{
    getKeyCode();
  }, []);

  return (
    <>
    <div className="App">
    </div>
    <div id='box' style={{left: '310px',width: '390px', height: '210px', justifyContent: 'center', alignItems: 'center', top: '300px', position: 'absolute', display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px'}}>
        {
          array.map((item) => (
            <div key={item} style={{marginLeft: `${item * 130}px`, backgroundPositionY: animation[item] + '%'}} className= {'lamelle lam' + item}>
            </div>
          ))
        }
      </div>
      {
        !gain &&
        <>
          <img src='./bg_qr_code.png' style={{position: 'absolute', zIndex: 50, width: '800px', left: '140px', top: '260px'}}/>
          <QRCodeCanvas 
          style={{position: 'absolute', top: '420px', left: '420px', zIndex: 1000, padding: '10px', backgroundColor: 'white'}}
          value={`https://mitchells.web-treeosk.online/back/?active=${key_code}`}
          size={200} // Taille en pixels
          bgColor={"#ffffff"} // Couleur de fond
          fgColor={"#000000"} // Couleur du code
          level={"H"} // Niveau de correction d'erreur (L, M, Q, H)
          />
        </>
      }
      {
        !!uri.length &&
        <div style={{position: 'absolute', top: '485px', left: '290px', zIndex: 1000, padding: '10px', backgroundColor: 'white'}}>
          <img src={uri} width={'500px'} height={'500px'}/>
        </div>
      }
    </>
  );
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export default App;